import React from "react";
import { Switch, Slider } from "./ToggleSwitchStyled";

export default function ToggleSwitch({
  name,
  isOn,
  save,
  myVolume,
  playSwitchSound,
}) {
  return (
    <label
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        marginBottom: "21px",
      }}
      onClick={() => {
        playSwitchSound();
        save();
      }}
    >
      <div>{name}</div>
      <Switch className="switch">
        <input defaultChecked={isOn} type="checkbox" />
        <Slider className="slider" />
      </Switch>
    </label>
  );
}
